import React from 'react';
import './App.css';
import {Navigate, Route, Routes} from "react-router-dom";
import Layout from "./components/layout";
import Home from "./pages/home";
import NotFound from "./pages/404";
import {ThemeProvider} from "@mui/material";
import theme from "./constants/theme";
import Login from "./pages/operator/login";
import AuthProvider from "./providers/AuthProvider";
import PrivateRoute from "./routes/protected-route";
import AdminLogin from "./pages/admin/login";
import AdminRoute from "./routes/admin-route";
import CreaOperatore from "./pages/admin/crea-operatore";
import CalendarioOperatore from "./pages/operator/calendario-operatore";
import CreaRaccolta from "./pages/operator/crea-raccolta";
import ConfermaCreaRaccolta from "./pages/operator/conferma-crea-raccolta";
import DettaglioRaccolta from "./pages/operator/dettaglio-raccolta";
import OperatoreAggiungiDonatore from "./pages/operator/dettaglio-raccolta/aggiungi-donatore";
import OperatoreSelezioneOrari from "./pages/operator/dettaglio-raccolta/aggiungi-donatore/selezione-orari";
import OperatoreRiepilogoPrenotazione
  from "./pages/operator/dettaglio-raccolta/aggiungi-donatore/selezione-orari/riepilogo-prenotazione";
import DonorRoute from "./routes/donor-route";
import EsitoPrenotazione
  from "./pages/operator/dettaglio-raccolta/aggiungi-donatore/selezione-orari/riepilogo-prenotazione/esito-prenotazione";
import RecuperoPassword from "./pages/operator/recupero-password";
import {SEZIONE_AVIS} from "./utils/config";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Navigate to={`/${SEZIONE_AVIS}`} replace />} />
          <Route path={`/${SEZIONE_AVIS}`} element={<Layout />}>
            <Route index={true} element={<Home />} />
            <Route path={`/${SEZIONE_AVIS}/donatore`} element={<Home />} />
            <Route path={`/${SEZIONE_AVIS}/*`} element={<NotFound />} />
            <Route path={`/${SEZIONE_AVIS}/donatore`} element={<DonorRoute />}>
              <Route path={`/${SEZIONE_AVIS}/donatore/gia-registrato`} element={<EsitoPrenotazione />} />
              <Route path={`/${SEZIONE_AVIS}/donatore/calendario`} element={<CalendarioOperatore />} />
              <Route path={`/${SEZIONE_AVIS}/donatore/raccolta/:raccoltaId/`} element={<OperatoreAggiungiDonatore />} />
              <Route path={`/${SEZIONE_AVIS}/donatore/raccolta/:raccoltaId/selezione-orari`} element={<OperatoreSelezioneOrari />} />
              <Route path={`/${SEZIONE_AVIS}/donatore/raccolta/:raccoltaId/selezione-orari/riepilogo-prenotazione`} element={<OperatoreRiepilogoPrenotazione />} />
              <Route path={`/${SEZIONE_AVIS}/donatore/raccolta/:raccoltaId/selezione-orari/riepilogo-prenotazione/esito-prenotazione`} element={<EsitoPrenotazione />} />
            </Route>
            <Route path={`/${SEZIONE_AVIS}/operatore`} element={<Login />} />
            <Route path={`/${SEZIONE_AVIS}/recupero-password`} element={<RecuperoPassword />} />
            <Route path={`/${SEZIONE_AVIS}/operatore`} element={<PrivateRoute />}>
              <Route path={`/${SEZIONE_AVIS}/operatore/calendario`} element={<CalendarioOperatore />} />
              <Route path={`/${SEZIONE_AVIS}/operatore/crea-raccolta`} element={<CreaRaccolta />} />
              <Route path={`/${SEZIONE_AVIS}/operatore/conferma-crea-raccolta`} element={<ConfermaCreaRaccolta />} />
              <Route path={`/${SEZIONE_AVIS}/operatore/dettaglio-raccolta/:raccoltaId`} element={<DettaglioRaccolta />} />
              <Route path={`/${SEZIONE_AVIS}/operatore/dettaglio-raccolta/:raccoltaId/aggiungi-donatore`} element={<OperatoreAggiungiDonatore />} />
              <Route path={`/${SEZIONE_AVIS}/operatore/dettaglio-raccolta/:raccoltaId/aggiungi-donatore/selezione-orari`} element={<OperatoreSelezioneOrari />} />
              <Route path={`/${SEZIONE_AVIS}/operatore/dettaglio-raccolta/:raccoltaId/aggiungi-donatore/selezione-orari/riepilogo-prenotazione`} element={<OperatoreRiepilogoPrenotazione />} />
              <Route path={`/${SEZIONE_AVIS}/operatore/dettaglio-raccolta/:raccoltaId/aggiungi-donatore/selezione-orari/riepilogo-prenotazione/esito-prenotazione`} element={<EsitoPrenotazione />} />
            </Route>
          </Route>
          <Route path={`/admin`} element={<AdminLogin />} />
          <Route path={`/admin`} element={<AdminRoute />}>
            <Route path={`/admin/crea-operatore`} element={<CreaOperatore />} />
          </Route>
        </Routes>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
